import { render } from "./LoanQuestionPage.vue?vue&type=template&id=a044aace&scoped=true"
import script from "./LoanQuestionPage.vue?vue&type=script&lang=js"
export * from "./LoanQuestionPage.vue?vue&type=script&lang=js"

import "./LoanQuestionPage.vue?vue&type=style&index=0&id=a044aace&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a044aace"]])

export default __exports__